<!-- Copyright 2023 Midas Healthcare Solutions - All Rights Reserved -->
<ng-container *transloco="let t">
  <div class="route-container" *ngIf="{ expanded: expandedOrgSideNav$ | async } as expandedCtx">    
    <div class="router-cont">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
